export enum EnumNavigationTrack {
    Burger = "burger",
    Logo = "logo",
    Search = "search",
    Sub = "sub",
    Main = "main",
}
